import { getUserDisplayName, getWorkDomainFromEmail } from '@gitbook/app-database';

import { capitalizeFirstLetter } from '../../utils';

/**
 * Get an initial name for organization.
 */
export function getOrgInitialTitle(user: {
    displayName?: string | null;
    email?: string | null;
}): string {
    if (user.email) {
        const workEmail = getWorkDomainFromEmail(user.email);
        if (workEmail) {
            return capitalizeFirstLetter(workEmail.replace(/\.[a-z0-9]+$/, ''));
        }
    }

    if (user.displayName) {
        return `${capitalizeFirstLetter(
            extractFirstName(getUserDisplayName(user))
        )}'s Organization`;
    }

    return '';
}

function extractFirstName(input: string): string {
    return input.split(/\s|\+/)[0] || '';
}
